<template>
    <transition name="app-switcher">
        <div
            class="app-switcher-overlay"
            ref="appSwitcher"
            :class="{ 'has-custom-apps': appSwitcherWebTabs.length > 0 }"
        >
            <div class="app-switcher-main">
                <!-- Sol: Supsis Core Uygulamaları -->
                <div class="app-switcher-content">
                    <div v-for="app in apps" :key="app.appKey" class="app-box">
                        <a class="app-link" :href="getAppHref(app)" @click="handleAppClick(app, $event)">
                            <a-icon
                                :type="app.antIcon"
                                :class="['app-icon', { 'is-ant-icon': app.antIcon }]"
                                v-if="app.antIcon"
                            />
                            <i
                                class="material-icons"
                                :class="['app-icon', { 'is-material-icon': app.materialIcon }]"
                                v-if="app.materialIcon"
                                >{{ app.materialIcon }}</i
                            >
                            <component :is="getIcon(app)" class="custom-app-icon" v-else />
                            <div class="app-name">{{ app.title }}</div>
                        </a>
                    </div>
                    <!-- Yeni Uygulama Butonu (WebTab yokken de görünsün) -->
                    <div v-if="appSwitcherWebTabs.length === 0" class="app-box add-app-box" @click="goToWebApps">
                        <div class="app-link">
                            <span class="material-icons app-icon add-icon">add_circle_outline</span>
                            <div class="app-name">{{ $t("message.newApp") }}</div>
                        </div>
                    </div>
                </div>

                <!-- Sağ: Müşteri WebTab Uygulamaları -->
                <div class="custom-apps-section" v-if="appSwitcherWebTabs.length > 0">
                    <div class="custom-apps-header">
                        <span class="material-icons">extension</span>
                        <span>{{ $t("message.customApps") }}</span>
                    </div>
                    <div class="custom-apps-grid">
                        <div
                            v-for="webTab in appSwitcherWebTabs"
                            :key="webTab._id"
                            class="app-box"
                            @click="handleWebTabClick(webTab, $event)"
                        >
                            <div class="app-link">
                                <span
                                    class="material-icons app-icon"
                                    :style="{ color: webTab.iconColor || '#C9BBF6' }"
                                    >{{ webTab.icon }}</span
                                >
                                <div class="app-name">{{ webTab.name }}</div>
                            </div>
                        </div>
                        <!-- Yeni Uygulama Yükle butonu -->
                        <div class="app-box add-app-box" @click="goToWebApps">
                            <div class="app-link">
                                <span class="material-icons app-icon add-icon">add_circle_outline</span>
                                <div class="app-name">{{ $t("message.newApp") }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Comments from "./svg/Comment";

import ChatIcon from "./svg/appSwitcherIcon/ChatIcon.vue";
import ChatbotIcon from "./svg/appSwitcherIcon/ChatbotIcon.vue";
import TableIcon from "./svg/appSwitcherIcon/TableIcon.vue";
import AutomationIcon from "./svg/appSwitcherIcon/AutomationIcon.vue";
import TaskIcon from "./svg/appSwitcherIcon/TaskIcon.vue";
import TicketIcon from "./svg/appSwitcherIcon/TicketIcon.vue";
import MailIcon from "./svg/appSwitcherIcon/MailIcon.vue";
import FormIcon from "./svg/appSwitcherIcon/FormIcon.vue";
import CalendarIcon from "./svg/appSwitcherIcon/CalendarIcon.vue";
import DriveIcon from "./svg/appSwitcherIcon/DriveIcon.vue";
import AiAgentIcon from "./svg/appSwitcherIcon/AiAgentIcon.vue";
import WebPhoneIcon from "./svg/appSwitcherIcon/WebPhoneIcon.vue";

export default {
    name: "AppSwitcher",
    components: {
        Comments,

        ChatIcon,
        ChatbotIcon,
        TableIcon,
        AutomationIcon,
        TaskIcon,
        TicketIcon,
        MailIcon,
        FormIcon,
        CalendarIcon,
        DriveIcon,
        AiAgentIcon,
        WebPhoneIcon,
    },
    props: {},
    data() {
        return {
            cancels: [],
            apps: [
                {
                    appKey: "chat",
                    title: this.$t("settings.Chat"),
                    icon: "ChatIcon",
                    route: "/chat",
                    superAdminPageKey: "customer-chat",
                    permissions: ["chat.get"],
                },
                {
                    appKey: "chatbot",
                    title: this.$t("chatbotv2.chatbot"),
                    icon: "ChatbotIcon",
                    route: "/chatbot",
                    superAdminPageKey: "customer-chatbot",
                    permissions: [
                        "chatbot.view",
                        "chatbot.stories.view",
                        "chatbot.templates.view",
                        "chatbot.aitemplates.view",
                        "chatbot.integrations.view",
                        "chatbot.archive.view",
                        "chatbot.entities.view",
                        "chatbot.reports.view",
                        "chatbot.training.view",
                    ],
                },
                {
                    appKey: "tables",
                    title: this.$t("tables.tables"),
                    icon: "TableIcon",
                    route: "/tables",
                    superAdminPageKey: "tables",
                    permissions: ["table.get"],
                },
                {
                    appKey: "automations",
                    title: this.$t("automation.automations"),
                    icon: "AutomationIcon",
                    route: "/automations",
                    superAdminPageKey: "automations",
                    permissions: ["automation.get"],
                },
                {
                    appKey: "tasks",
                    title: this.$t("calendar.tasks"),
                    icon: "TaskIcon",
                    route: "/tasks",
                    superAdminPageKey: "customer-tasks",
                    permissions: ["task.read"],
                },
                {
                    appKey: "ticket",
                    title: this.$t("ticket.tickets"),
                    icon: "TicketIcon",
                    route: "/ticket",
                    superAdminPageKey: "customer-ticket",
                    permissions: ["offlineSupportRequest.get"],
                },
                {
                    appKey: "mails",
                    title: this.$t("message.mails"),
                    icon: "MailIcon",
                    route: "/mails",
                    superAdminPageKey: "customer-mails",
                    permissions: ["mail.read"],
                },
                {
                    appKey: "form",
                    title: this.$t("form.forms"),
                    icon: "FormIcon",
                    route: "/form",
                    superAdminPageKey: "customer-forms",
                    permissions: ["form.get"],
                },
                {
                    appKey: "calendar",
                    title: this.$t("tables.calendar"),
                    icon: "CalendarIcon",
                    route: "/calendar",
                    superAdminPageKey: "customer-calendar",
                    permissions: ["calendar.read"],
                },
                {
                    appKey: "drive",
                    title: "Drive",
                    icon: "DriveIcon",
                    route: "/drive",
                    superAdminPageKey: "customer-drive",
                    permissions: ["drive.get"],
                },
                {
                    appKey: "voice-agent",
                    title: this.$t("menu.aiVoiceAgent"),
                    icon: "AiAgentIcon",
                    route: "/integrations/voice-agent",
                    superAdminPageKey: "voice-agent",
                    permissions: ["voice-agent.get"],
                },
                {
                    appKey: "webphone",
                    title: this.$t("menu.webphone"),
                    icon: "WebPhoneIcon",
                    route: "/integrations/webphone/netgsm",
                    superAdminPageKey: "webphone",
                    permissions: [],
                },
            ],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            isAdmin: (state) => state.auth.adminUser != null,
            adminUser: (state) => state.auth.adminUser,
            webphoneChannelsRedSantral: (state) =>
                state.channel.channels.filter((c) => c.type === "webphone-kirmizisantral"),
            webphoneChannelsNetGsm: (state) => state.channel.channels.filter((c) => c.type === "webphone-netgsm"),

            webphoneChannelsTelnyx: (state) => state.channel.channels.filter((c) => c.type === "webphone-telnyx"),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
            appSwitcherWebTabs: "webtabs/getAppSwitcherWebTabs",
            getWebTabUrl: "webtabs/getWebTabUrl",
        }),
        allowedApps() {
            let appSwitcherApps = this.apps;
            if (!this.isAdmin) {
                appSwitcherApps = appSwitcherApps.filter((app) => {
                    if (this.user.role.isRoot) return true;
                    return !!this.user.role.permissions.find((userPermission) => {
                        if (!app.permissions?.length) return true;
                        return app.permissions.includes(userPermission.name);
                    });
                });
            }
            // Süper admin için tüm uygulamaları göster, yetki kontrolü tıklamada yapılacak
            return appSwitcherApps;
        },
    },
    methods: {
        hasSuperAdminAccess(superAdminPageKey) {
            if (!this.isAdmin) return true;
            if (!this.adminUser) return true;
            if (this.adminUser.isFullAccess) return true;
            if (!superAdminPageKey) return true;
            return (this.adminUser.approvedPages || []).map((x) => x.page).includes(superAdminPageKey);
        },
        isAllowed(key) {
            if (key === "customer-drive" || key === "webphone") return true;
            if (this.isAdmin) {
                return this.hasSuperAdminAccess(key);
            }
            return this.allowedApps.find((app) => app.superAdminPageKey === key);
        },
        close(target) {
            console.log("[AppSwitcher] close", target);
            this.$emit("close");
        },
        getIcon(app) {
            return app.icon;
        },
        getAppHref(app) {
            if (!this.isAllowed(app.superAdminPageKey)) {
                return "#/";
            }

            if (app.appKey === "voice-agent") {
                const voiceAgentChannels = this.$store.state.channel.channels.filter((c) => c.type === "retell");
                if (voiceAgentChannels.length > 0) {
                    return `#/integrations/voice-agent/${voiceAgentChannels[0]._id}/dashboard`;
                }
            }

            if (app.appKey === "webphone") {
                if (this.webphoneChannelsNetGsm.length > 0) {
                    return `#/integrations/webphone/netgsm/${this.webphoneChannelsNetGsm[0]._id}/detail`;
                } else if (this.webphoneChannelsRedSantral.length > 0) {
                    return `#/integrations/webphone/redsantral/${this.webphoneChannelsRedSantral[0]._id}/detail`;
                } else if (this.webphoneChannelsTelnyx.length > 0) {
                    return `#/integrations/webphone/telnyx/${this.webphoneChannelsTelnyx[0]._id}/detail`;
                }
            }
            return `#${app.route}`;
        },
        handleKeydown(event) {
            if (event.key === "Escape") {
                this.close("esc");
            }
        },
        handleClick(event) {
            const appSwitcher = this.$refs.appSwitcher;
            if (!appSwitcher.contains(event.target)) {
                this.close("click");
            }
        },
        handleAppClick(app, event) {
            // Süper admin yetki kontrolü
            if (this.isAdmin && app.superAdminPageKey) {
                if (!this.hasSuperAdminAccess(app.superAdminPageKey)) {
                    event.preventDefault();
                    this.$router.push("/");
                    this.close("navigation");
                    return;
                }
            }

            // Command/Ctrl + Click durumunda tarayıcının varsayılan davranışına izin ver
            if (event.metaKey || event.ctrlKey) {
                if (this.isAllowed(app.superAdminPageKey)) {
                    this.close("navigation");
                    return; // Tarayıcının varsayılan davranışına izin ver
                } else {
                    event.preventDefault();
                    this.$router.push("/");
                    this.close("navigation");
                }
            } else {
                // Normal tıklama durumunda varsayılan davranışı engelle ve router kullan
                event.preventDefault();
                if (this.isAllowed(app.superAdminPageKey)) {
                    if (app.appKey === "voice-agent") {
                        const voiceAgentChannels = this.$store.state.channel.channels.filter(
                            (c) => c.type === "retell"
                        );
                        if (voiceAgentChannels.length > 0) {
                            this.$router.push(`/integrations/voice-agent/${voiceAgentChannels[0]._id}/dashboard`);
                        } else {
                            this.$router.push(app.route);
                        }
                    } else if (app.appKey === "webphone") {
                        if (this.webphoneChannelsNetGsm.length > 0) {
                            this.$router.push(
                                `/integrations/webphone/netgsm/${this.webphoneChannelsNetGsm[0]._id}/detail`
                            );
                        } else if (this.webphoneChannelsRedSantral.length > 0) {
                            this.$router.push(
                                `/integrations/webphone/redsantral/${this.webphoneChannelsRedSantral[0]._id}/detail`
                            );
                        } else if (this.webphoneChannelsTelnyx.length > 0) {
                            this.$router.push(
                                `/integrations/webphone/telnyx/${this.webphoneChannelsTelnyx[0]._id}/detail`
                            );
                        } else {
                            this.$router.push(app.route);
                        }
                    } else {
                        this.$router.push(app.route);
                    }
                    this.close("navigation");
                } else {
                    this.$router.push("/");
                    this.close("navigation");
                }
            }
        },
        handleWebTabClick(webTab, event) {
            // Command/Ctrl + Click: Yeni sekmede URL'yi aç (parametreleri bind ettikten sonra)
            if (event && (event.metaKey || event.ctrlKey)) {
                var url = this.getWebTabUrl(webTab);
                if (url) {
                    window.open(url, "_blank");
                }
                this.close("webtab-external");
            } else {
                // Normal tıklama: /webtab/:id route'una git
                this.$router.push(`/webtab/${webTab._id}`);
                this.close("webtab-navigation");
            }
        },
        goToWebApps() {
            this.$router.push("/integrations/webapps");
            this.close("navigation");
        },
    },
    mounted() {
        const handleKeydown = this.handleKeydown;
        const handleClick = this.handleClick;
        window.addEventListener("keydown", handleKeydown);
        window.addEventListener("click", handleClick);
        this.cancels.push(() => {
            window.removeEventListener("keydown", handleKeydown);
            window.removeEventListener("click", handleClick);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
};
</script>

<style lang="scss">
.app-switcher-overlay {
    position: fixed;
    background: linear-gradient(90deg, #f7f6fe, #e7e2ff);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(79, 70, 229, 0.15);
    z-index: 1000;
    top: 45px;
    left: 55px;
    border-top-left-radius: 20px;
    padding: 24px;
    backdrop-filter: blur(10px);

    &.has-custom-apps {
        .app-switcher-main {
            display: flex;
            gap: 24px;
        }
    }
}

.app-switcher-main {
    display: flex;
}

.custom-apps-section {
    min-width: 400px;
    border-left: 1px solid rgba(99, 102, 241, 0.15);
    padding-left: 24px;
    display: flex;
    flex-direction: column;

    .custom-apps-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(99, 102, 241, 0.1);
        color: #5625cc;
        font-weight: 600;
        font-size: 13px;

        .material-icons {
            font-size: 18px;
        }
    }

    .custom-apps-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        max-width: 380px;
        max-height: 320px;
        overflow-y: auto;

        .app-box {
            flex: 0 0 calc(50% - 8px);
            padding: 10px;
            background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
            border: 1px solid rgba(229, 231, 235, 0.5);
            border-radius: 12px;
            transition: all 0.3s ease;
            cursor: pointer;
            position: relative;
            overflow: hidden;

            &:hover {
                .app-name {
                    color: #1c1b1f;
                }

                .app-icon {
                    color: #5625cc !important;
                }
            }

            &.add-app-box {
                border: 1px dashed rgba(86, 37, 204, 0.3);
                background: rgba(86, 37, 204, 0.03);

                .add-icon {
                    color: #5625cc !important;
                }

                .app-name {
                    color: #5625cc;
                }

                &:hover {
                    border-color: #5625cc;
                    background: rgba(86, 37, 204, 0.08);
                }
            }

            .app-link {
                text-decoration: none;
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 12px;
                color: inherit;
                position: relative;
                z-index: 1;
                cursor: pointer;
            }

            .app-icon {
                font-size: 24px;
                flex-shrink: 0;
                transition: color 0.3s ease;
            }

            .app-name {
                font-family: "Inter", sans-serif;
                font-size: 15px;
                font-weight: 500;
                line-height: 16px;
                color: #3a3f48;
                transition: all 0.3s ease;
                text-align: left;
            }
        }
    }
}

.app-switcher-enter-active {
    animation: zoomIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.app-switcher-leave-active {
    animation: explode 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes zoomIn {
    0% {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

@keyframes explode {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(1.1) rotate(2deg);
    }
}

.app-switcher-content {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    max-width: 380px;

    .app-box {
        flex: 0 0 calc(50% - 8px);
        padding: 10px;
        background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
        border: 1px solid rgba(229, 231, 235, 0.5);
        border-radius: 12px;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &.add-app-box {
            border: 1px dashed rgba(86, 37, 204, 0.3);
            background: rgba(86, 37, 204, 0.03);
            flex: 0 0 calc(100%) !important;
            display: flex;
            justify-content: center;

            .add-icon {
                color: #5625cc !important;
            }

            .app-name {
                color: #5625cc;
            }

            &:hover {
                border-color: #5625cc;
                background: rgba(86, 37, 204, 0.08);
            }
        }

        &:hover {
            .app-name {
                color: #1c1b1f;
            }

            .custom-app-icon {
                color: #5625cc;

                :deep(svg) {
                    fill: currentColor !important;

                    path {
                        fill: currentColor !important;
                    }
                }
            }

            .app-icon {
                color: #5625cc;
            }

            .app-icon.is-ant-icon {
                :deep(.anticon) {
                    color: #5625cc;

                    svg {
                        fill: currentColor !important;

                        path {
                            fill: currentColor !important;
                        }
                    }
                }
            }

            .app-icon.is-material-icon {
                color: #5625cc;
            }
        }

        .app-icon,
        .custom-app-icon {
            font-size: 24px;
            margin-bottom: 0;
            transition: transform 0.3s ease;
            flex-shrink: 0;
            color: #c9bbf6;

            :deep(svg) {
                fill: currentColor !important;

                path {
                    fill: currentColor !important;
                }
            }

            &.is-ant-icon {
                :deep(.anticon) {
                    color: #c9bbf6;

                    svg {
                        fill: currentColor !important;

                        path {
                            fill: currentColor !important;
                        }
                    }
                }
            }

            &.is-material-icon {
                color: #c9bbf6;
            }
        }

        .custom-app-icon {
            width: 24px;
            height: 24px;
        }

        .app-name {
            font-family: "Inter", sans-serif;
            font-size: 15px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: 0%;
            color: #3a3f48;
            transition: all 0.3s ease;
            text-align: left;
        }

        .app-link {
            text-decoration: none;
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 12px;
            color: inherit;
            position: relative;
            z-index: 1;
            cursor: pointer;
        }
    }
}

@keyframes lightBeam {
    0% {
        transform: translate(-100%, -100%) rotate(-45deg);
    }
    100% {
        transform: translate(100%, 100%) rotate(-45deg);
    }
}

@keyframes pulse {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.7;
    }
    100% {
        opacity: 1;
    }
}
</style>
